import { render, staticRenderFns } from "./OrderBookings.vue?vue&type=template&id=dd8cf8f8&scoped=true"
import script from "./OrderBookings.vue?vue&type=script&lang=js"
export * from "./OrderBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8cf8f8",
  null
  
)

export default component.exports